import React, { AnchorHTMLAttributes } from 'react';
import Url from 'url-parse';

import {
  KnownService,
  KnownServiceComponentProps,
} from './known-services/known-service';

import { FogBugzCase } from './known-services/fogbugz-case';
import { GitHubCommit } from './known-services/github-commit';
import { GitHubIssue } from './known-services/github-issue';
import { GitHubPullRequest } from './known-services/github-pr';
import { KilnCase } from './known-services/kiln-case';
import { TrelloAction } from './known-services/trello-action';
import { TrelloBoard } from './known-services/trello-board';
import { TrelloCard } from './known-services/trello-card';
import { SmartLink } from 'app/src/components/SmartMedia';
const { featureFlagClient } = require('@trello/feature-flag-client');

export class FriendlyLink extends React.PureComponent<
  AnchorHTMLAttributes<HTMLAnchorElement>
> {
  knownServices: KnownService<KnownServiceComponentProps>[] = [];
  isSmartLinkFeatureFlagOn = false;

  constructor(props: AnchorHTMLAttributes<HTMLAnchorElement>) {
    super(props);

    this.isSmartLinkFeatureFlagOn = featureFlagClient.get(
      'growth.trello-smart-links-render',
      false,
    );

    const defaultKnownServicesList: KnownService<KnownServiceComponentProps>[] = [
      TrelloBoard,
      TrelloAction,
      TrelloCard,
      FogBugzCase,
      KilnCase,
    ];

    if (this.isSmartLinkFeatureFlagOn) {
      this.knownServices = defaultKnownServicesList;
    } else {
      this.knownServices = [
        ...defaultKnownServicesList,
        GitHubCommit,
        GitHubIssue,
        GitHubPullRequest,
      ];
    }
  }

  render() {
    const { href, children, ...props } = this.props;
    const plainLink = () => <a {...this.props} />;

    // if href !== children then we want to show the link name that the user set
    if (href && href === children) {
      for (const knownService of this.knownServices) {
        const matchedValues = this.execMatch(knownService, href);

        if (matchedValues !== null) {
          const { Component, getMatchProps } = knownService;

          return <Component {...props} {...getMatchProps(matchedValues)} />;
        }
      }

      if (this.isSmartLinkFeatureFlagOn) {
        return <SmartLink url={href} plainLink={plainLink} />;
      }
    }

    return plainLink();
  }

  execMatch = (
    { match }: KnownService<KnownServiceComponentProps>,
    url: string,
  ) => {
    const parsed = new Url(url);
    let matchedValues = [parsed.href, parsed.pathname];

    let key: keyof KnownService<KnownServiceComponentProps>['match'];
    for (key in match) {
      const expected = match[key];

      if (typeof expected === 'string') {
        if (expected !== parsed[key]) {
          return null;
        }
      } else if (expected instanceof RegExp) {
        const regexp = parsed[key];
        const results =
          typeof regexp === 'string' ? expected.exec(regexp) : null;

        if (results !== null) {
          matchedValues = [...matchedValues, ...results.slice(1)];
        } else {
          return null;
        }
      } else {
        throw Error('Invalid specification');
      }
    }

    return matchedValues;
  };
}
